module.exports = __webpack_public_path__ + "img/yuxi-166a5d.png";